import React from 'react';
import { FileText, Download } from 'lucide-react';
import { Button } from '../components/ui/button';

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 text-center">
          <FileText className="h-16 w-16 text-emerald-600 mx-auto mb-6" />
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Privacy Policy Statement
          </h2>
          <p className="text-gray-600 mb-8">
            Our complete privacy policy is available as a PDF document.
          </p>
          <a 
            href="https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/cf3ix3c9_POL.11%20Privacy%20Policy%20Statement.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="bg-emerald-600 hover:bg-emerald-700 text-white" size="lg">
              <Download className="h-5 w-5 mr-2" />
              Download Privacy Policy (PDF)
            </Button>
          </a>
          <p className="text-sm text-gray-500 mt-6">
            For any questions regarding our privacy policy, please contact us at{' '}
            <a href="mailto:contact@greenfrogutilities.co.uk" className="text-emerald-600 hover:text-emerald-700">
              contact@greenfrogutilities.co.uk
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
